import {
  dimensiondata_1_tetelek_group_dimension_1_2_3_column,
  ezer_kobmeter_value_1_data,
  megawatt_ora_value_2,
  month_row,
  year_row_expanded,
  order_1,
  order_2
} from '../../fields';
import { PivotGridConfig } from '../../utils/pivot-grid-config';

export const rendszerHaviGazMerlegConfig: PivotGridConfig = {
  showChart: false,
  filterYear: {},
  options: {
    store: {
      version: 4,
      type: 'odata',
      url: 'odata/v4/public/RendszerHaviGazMerleg',
      select: ['date', 'dimension_1', 'value_1', 'value_2'],
      beforeSend: (e: any) => {
        e.headers = {
          Accept: 'application/json;odata.metadata=none',
        };
      },
    },
    retrieveFields: false,
    fields: [
      year_row_expanded,
      month_row,
      ...dimensiondata_1_tetelek_group_dimension_1_2_3_column,
      ezer_kobmeter_value_1_data,
      megawatt_ora_value_2,
      order_1,
      order_2
    ],
  },
};
